var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H4.5C4.086 3.75 3.75 4.086 3.75 4.5V19.5C3.75 19.914 4.086 20.25 4.5 20.25H19.5C19.914 20.25 20.25 19.914 20.25 19.5V4.5C20.25 4.086 19.914 3.75 19.5 3.75ZM18.75 18.75H5.25V5.25H18.75V18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.104 15.174C10.245 15.315 10.436 15.394 10.634 15.394C10.832 15.394 11.024 15.315 11.164 15.174L16.451 9.88597C16.744 9.59297 16.744 9.11797 16.451 8.82497C16.158 8.53197 15.683 8.53197 15.39 8.82497L10.633 13.582L8.609 11.558C8.316 11.265 7.841 11.265 7.548 11.558C7.255 11.851 7.255 12.326 7.548 12.619L10.104 15.174Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.dc3550f62f35948d3beba7799c4b2fc8.svg";
export { ForwardRef as ReactComponent };